import { AXIS_LABEL_COLOR } from "../constants";
import {
  createAnalyticsTooltipHtml,
  createAnalyticsTooltipResult,
  type AnalyticsTooltipRow,
  type AnalyticsTooltipResult,
} from "../utils/createAnalyticsTooltip";
import { formatAnalyticsCurrency, formatAnalyticsNumber } from "../utils/formatAnalyticsNumber";

import type { CustomChartResponseItem } from "@/queries/analytics-custom-charts-types";

const DURATION_AXIS_DECIMAL_PLACES = 2;

export const formatAxisValue = (unit: string, value: number): string => {
  switch (unit) {
    case "currency":
      return formatAnalyticsCurrency(value);
    case "duration_seconds":
      return `${value.toFixed(DURATION_AXIS_DECIMAL_PLACES)}s`;
    case "tokens":
    case "count":
      return formatAnalyticsNumber(value);
    default:
      return value.toLocaleString();
  }
};

export const buildDerivedInsightRows = (chart: CustomChartResponseItem): AnalyticsTooltipRow[] =>
  (chart.derivedInsights ?? []).map(insight => ({
    label: insight.label,
    value: insight.value.toFixed(DURATION_AXIS_DECIMAL_PLACES),
    color: AXIS_LABEL_COLOR,
  }));

export { createAnalyticsTooltipHtml, createAnalyticsTooltipResult };
export type { AnalyticsTooltipRow, AnalyticsTooltipResult };
